const STORAGE_KEY = "notifications";

export function getNotifications() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    return [];
  }
}

export function saveNotifications(list) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(list || []));
}

export function addNotification(notification, { max = 30 } = {}) {
  const list = getNotifications();
  const next = [notification, ...list].slice(0, max);
  saveNotifications(next);

  // UI'lar dinleyebilsin diye event yayınla
  window.dispatchEvent(
    new CustomEvent("ptduo:notification", { detail: notification })
  );

  return next;
}

export function addRaiseMsgNotification(payload = {}, topic = "") {
  const id = payload.messageId || `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  const created = payload.createdTime ? new Date(payload.createdTime) : new Date();
  const time = isNaN(created.getTime())
    ? new Date().toLocaleString("tr-TR")
    : created.toLocaleString("tr-TR");

  const notification = {
    id,
    type: "RaiseMsg",
    title: "Yeni Bildirim",
    message: "Yeni bildiriminiz var.",
    time,
    isRead: false,
    topic,
    payload
  };

  return addNotification(notification);
}

